module.exports = __webpack_public_path__ + "img/blueSearch.158c04c1.svg";